import { useQuery } from "@tanstack/react-query";
import type { AxiosError } from "axios";

import { httpService } from "~/core/http_service";

import type { CountryListResponse } from "../types";
import { usersKeys } from "./get-user-information.api";

const getUserCountryList = (): Promise<CountryListResponse> => {
  return httpService.get<CountryListResponse>("/users/country/");
};

export const useGetUserCountryList = () => {
  return useQuery<CountryListResponse, AxiosError>({
    queryKey: usersKeys.countries(),
    queryFn: getUserCountryList,
    staleTime: 5 * 60_000,
  });
};
